<template>
    <div style="min-height: 77.8vh;" id="videoModule">
        <Layout>
            <Sider style="min-width: 200px; background: #fff;">
                <div id="anchorContent">
                    <Anchor show-ink style="margin: 5px;">
                        <!--   <AnchorLink href="#demovideo" title="PC端演示视频"> -->
                        <AnchorLink href="#pcvideo" title="PC端演示视频">
                            <AnchorLink href="#pcvideo1" title="功能模块类" />
                            <AnchorLink href="#pcvideo2" title="应用场景类" />
                        </AnchorLink>
                        <AnchorLink href="#mobilevideo" title="移动端">
                            <AnchorLink href="#mobilevideo1" title="功能模块类" />
                            <AnchorLink href="#mobilevideo2" title="应用场景类" />
                        </AnchorLink>
                        <!--            </AnchorLink> -->
                    </Anchor>
                </div>
            </Sider>
            <Layout>
                <Content>
                    <div>
                        <!--    <H3 id="demovideo">演示视频</H3> -->
                        <Divider dashed orientation="left" id="pcvideo">PC端演示视频</Divider>
                        <Divider dashed orientation="left" id="pcvideo1">功能模块类</Divider>
                        <div v-for="(item, index) in pcFunction" :key="item.id">
                            <Card style="width:500px;cursor:pointer;float:left;margin:20px;">
                                <div style="text-align:center;" @click="playVidel(item,index)" @mouseover="previewImg(item, index)" @mouseout="backBgImg(item)">
                                    <!-- <video v-if="item.titlepage" :poster="item.titlepage" id="video">
                    <source :src="item.fileurl" type="video/mp4">
                  </video>-->
                                    <img v-if="item.titlepage" :src="item.titlepage" class="cover-img" />
                                    <img v-else-if="mouseoverFlag1 && mouseoverIndex1 === index && mouseroverid===item.id" src="../../assets/images/video/mengceng.png" class="cover-img" />
                                    <img v-else src="../../assets/images/video/bg.jpg" class="cover-img" />
                                    <h3>{{item.title}}</h3>
                                </div>
                            </Card>
                        </div>
                        <Divider dashed orientation="left" id="pcvideo2">应用场景类</Divider>
                        <div v-for="(item, index) in pcApplication" :key="item.id">
                            <Card style="width:500px;cursor:pointer;float:left;margin:20px;">
                                <div style="text-align:center;" @click="playVidel(item,index)" @mouseover="previewImg(item, index)" @mouseout="backBgImg(item)">
                                    <img v-if="item.titlepage" :src="item.titlepage" class="cover-img" />
                                    <img v-else-if="mouseoverFlag2 && mouseoverIndex2 === index && mouseroverid===item.id" src="../../assets/images/video/mengceng.png" class="cover-img" />
                                    <img v-else src="../../assets/images/video/bg.jpg" class="cover-img" />
                                    <h3>{{item.title}}</h3>
                                </div>
                            </Card>
                        </div>
                        <Divider dashed orientation="left" id="mobilevideo">移动端</Divider>
                        <Divider dashed orientation="left" id="mobilevideo1">功能模块类</Divider>
                        <div v-for="(item, index) in mobileFunction" :key="item.id">
                            <Card style="width:500px;cursor:pointer;float:left;margin:20px;">
                                <div style="text-align:center;" @click="playVidel(item,index)" @mouseover="previewImg(item, index)" @mouseout="backBgImg(item)">
                                    <!-- <video v-if="item.titlepage" :poster="item.titlepage" id="video">
                    <source :src="item.fileurl" type="video/mp4">
                  </video>-->
                                    <img v-if="item.titlepage" :src="item.titlepage" class="cover-img" />
                                    <img v-else-if="mouseoverFlag1 && mouseoverIndex1 === index && mouseroverid===item.id" src="../../assets/images/video/mengceng.png" class="cover-img" />
                                    <img v-else src="../../assets/images/video/bg.jpg" class="cover-img" />
                                    <h3>{{item.title}}</h3>
                                </div>
                            </Card>
                        </div>
                        <Divider dashed orientation="left" id="mobilevideo2">应用场景类</Divider>
                        <div v-for="(item, index) in mobileApplication" :key="item.id">
                            <Card style="width:500px;cursor:pointer;float:left;margin:20px;">
                                <div style="text-align:center;" @click="playVidel(item,index)" @mouseover="previewImg(item, index)" @mouseout="backBgImg(item)">
                                    <img v-if="item.titlepage" :src="item.titlepage" class="cover-img" />
                                    <img v-else-if="mouseoverFlag2 && mouseoverIndex2 === index && mouseroverid===item.id" src="../../assets/images/video/mengceng.png" class="cover-img" />
                                    <img v-else src="../../assets/images/video/bg.jpg" class="cover-img" />
                                    <h3>{{item.title}}</h3>
                                </div>
                            </Card>
                        </div>
                    </div>
                </Content>
            </Layout>
        </Layout>
        <Modal v-model="modal11" class-name="modal-warp" :title="showPlayVideoTitle" fullscreen footer-hide @on-cancel="cancelButton">
            <Row class-name="modalStyle">
                <Col :span="20">
                <div ref="videoDiv" v-show="playSwitchto===1" class="iframe_video">
                </div>
                <div ref="iframeDiv" v-show="playSwitchto===2" class="iframe_video">
                </div>
                </Col>
                <Col span="4" :style="menuList">
                <div :style="menuTabs" style="line-height: 50px;">
                    <p :style="[menuTab,{borderBottom: (videoPcType === 1 ? '2px solid #F0691C' : '2px solid #fff')},{color: (videoPcType === 1 ? '#F0691C' : '#fff')}]" @click="changeTab(1)">功能模块类</p>
                    <p :style="[menuTab,{borderBottom: (videoPcType === 2 ? '2px solid #F0691C' : '2px solid #fff')},{color: (videoPcType === 2 ? '#F0691C' : '#fff')}]" @click="changeTab(2)">应用场景类</p>
                </div>
                <div :style="menuListContent">
                    <div v-if="videoPcType === 1&&videoSource ===1">
                        <div v-for="(item, index) in pcFunction" :key="item.id" :style="[menuListContentItem, {color: (playFunVideoIndex === index ? '#F0691C' : '#fff')}, {background: (playFunVideoIndex === index ? '#1B222E' : (mouseoverFlagTab1 && playFunVideoIndex !== mouseoverIndexTab1 && mouseoverIndexTab1 === index ? '#263041' : ''))}]" @mouseover="videoHoverStyle(item, index)" @mouseout="videoOutStyle(item)" @click="playVideo(item, index)">
                            <p v-if="playFunVideoIndex === index && watchVideoPlayOrStop">
                                <img :style="[playImg, {width: '16px'}, {height: '16px'}, {marginRight: '9px'}]" src="../../assets/images/video/2.gif" alt />
                            </p>
                            <p v-else-if="playFunVideoIndex === index && !watchVideoPlayOrStop">
                                <img :style="playImg" src="../../assets/images/video/stop.png" alt />
                            </p>
                            <p v-else>
                                <img :style="playImg" src="../../assets/images/video/play.png" alt />
                            </p>
                            <p :style="menuTitle">{{item.title}}</p>
                        </div>
                    </div>
                    <div v-if="videoPcType === 2&&videoSource ===1">
                        <div v-for="(item, index) in pcApplication" :key="item.id" :style="[menuListContentItem, {color: (playAppVideoIndex === index ? '#F0691C' : '#fff')}, {background: (playAppVideoIndex === index ? '#1B222E' : (mouseoverFlagTab2 && playAppVideoIndex !== mouseoverIndexTab2 && mouseoverIndexTab2 === index ? '#263041' : ''))}]" @mouseover="videoHoverStyle(item, index)" @mouseout="videoOutStyle(item)" @click="playVideo(item, index)">
                            <p v-if="playAppVideoIndex === index && watchVideoPlayOrStop">
                                <img :style="[playImg, {width: '16px'}, {height: '16px'}, {marginRight: '9px'}]" src="../../assets/images/video/2.gif" alt />
                            </p>
                            <p v-else-if="playAppVideoIndex === index && !watchVideoPlayOrStop">
                                <img :style="playImg" src="../../assets/images/video/stop.png" alt />
                            </p>
                            <p v-else>
                                <img :style="playImg" src="../../assets/images/video/play.png" alt />
                            </p>
                            <p :style="menuTitle">{{item.title}}</p>
                        </div>
                    </div>
                    <div v-if="videoPcType === 1&&videoSource ===2">
                        <div v-for="(item, index) in mobileFunction" :key="item.id" :style="[menuListContentItem, {color: (playFunVideoIndex === index ? '#F0691C' : '#fff')}, {background: (playFunVideoIndex === index ? '#1B222E' : (mouseoverFlagTab1 && playFunVideoIndex !== mouseoverIndexTab1 && mouseoverIndexTab1 === index ? '#263041' : ''))}]" @mouseover="videoHoverStyle(item, index)" @mouseout="videoOutStyle(item)" @click="playVideo(item, index)">
                            <p v-if="playFunVideoIndex === index && watchVideoPlayOrStop">
                                <img :style="[playImg, {width: '16px'}, {height: '16px'}, {marginRight: '9px'}]" src="../../assets/images/video/2.gif" alt />
                            </p>
                            <p v-else-if="playFunVideoIndex === index && !watchVideoPlayOrStop">
                                <img :style="playImg" src="../../assets/images/video/stop.png" alt />
                            </p>
                            <p v-else>
                                <img :style="playImg" src="../../assets/images/video/play.png" alt />
                            </p>
                            <p :style="menuTitle">{{item.title}}</p>
                        </div>
                    </div>
                    <div v-if="videoPcType === 2&&videoSource ===2">
                        <div v-for="(item, index) in mobileApplication" :key="item.id" :style="[menuListContentItem, {color: (playAppVideoIndex === index ? '#F0691C' : '#fff')}, {background: (playAppVideoIndex === index ? '#1B222E' : (mouseoverFlagTab2 && playAppVideoIndex !== mouseoverIndexTab2 && mouseoverIndexTab2 === index ? '#263041' : ''))}]" @mouseover="videoHoverStyle(item, index)" @mouseout="videoOutStyle(item)" @click="playVideo(item, index)">
                            <p v-if="playAppVideoIndex === index && watchVideoPlayOrStop">
                                <img :style="[playImg, {width: '16px'}, {height: '16px'}, {marginRight: '9px'}]" src="../../assets/images/video/2.gif" alt />
                            </p>
                            <p v-else-if="playAppVideoIndex === index && !watchVideoPlayOrStop">
                                <img :style="playImg" src="../../assets/images/video/stop.png" alt />
                            </p>
                            <p v-else>
                                <img :style="playImg" src="../../assets/images/video/play.png" alt />
                            </p>
                            <p :style="menuTitle">{{item.title}}</p>
                        </div>
                    </div>
                </div>
                </Col>
            </Row>
        </Modal>
    </div>
</template>
<script>
import {
    randomWord,
    getTimeStamp,
    getAeskey2,
} from '../../api/lib/sign.js'
import md5 from 'js-md5'
import TripleDES from '../../api/lib/crypto.js'
import axios from 'axios'
import { reqTempVideo } from '../../api/security/tempuser'
//import baseConfig from '../../../public/config.json'
//http://120.24.183.196:20205/api/
//https://www.holywiser.com/api

// const ajax2 = axios.create({
//     baseURL: baseConfig.wxServletUrl,
// })

export default {
    name: "uservideo",
    data() {
        return {
            mouseroverid: -1,
            playItem: {},
            videoLists: [],
            pcFunction: [],
            pcApplication: [],
            mobileFunction: [],
            mobileApplication: [],
            modal11: false,
            videoPcType: 1,
            videoSource: 1,
            playFileurl: '',
            playFunVideoIndex: -1,
            playAppVideoIndex: -1,
            playSwitchto: 1,
            showPlayVideoTitle: '',
            mouseoverFlag1: false,
            mouseoverFlag2: false,
            mouseoverIndex1: -1,
            mouseoverIndex2: -1,
            mouseoverFlagTab1: false,
            mouseoverFlagTab2: false,
            mouseoverIndexTab1: -1,
            mouseoverIndexTab2: -1,
            watchVideoPlayOrStop: true,

            changeVideoStyle: {
                width: '97.8%',

            },
            menuList: {
                //height: '1200px;',
                background: '#39455F'
            },
            menuTabs: {
                display: 'flex',
                height: '5%'
            },
            menuTab: {
                flex: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                borderBottom: '2px solid #fff'
            },
            menuListContent: {
                height: '95%',
                overflowY: 'auto'
            },
            menuListContentItem: {
                display: 'flex',
                height: '50px',
                lineHeight: '50px',
                cursor: 'pointer',
                borderBottom: '1px solid #465269',
                fontSize: '14px'
            },
            playImg: {
                flex: '0 0 20px',
                height: '20px',
                marginRight: '4px',
                marginLeft: '4px',
                marginTop: '15px'
            },
            menuTitle: {
                flex: '1',
                width: '238px',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
            }
        }
    },
    mounted() {
        this.getVideoList1()
        this.watchControlsClick()
    },
    methods: {
        // 关闭模态框暂停视频

        clearIframeVideo() {
            console.log('clearVideo====>')
            // console.log('this.playItem.switchto:' + this.playItem.switchto)
            // console.log(this.$refs.iframeDiv)
            // console.log(this.$refs.videoDiv)

            if (this.$refs.iframeDiv) {
                this.$refs.iframeDiv.innerHTML = ''
            }

            if (this.$refs.videoDiv) {
                this.$refs.videoDiv.innerHTML = ''
            }
        },

        cancelButton() {

            this.clearIframeVideo()

            // if (this.playItem.switchto === 1) {
            //     let video = document.getElementById('video')
            //     video.pause()
            // } else if (this.playItem.switchto === 2) {
            //     this.clearIframeVideo()
            // }


            //console.log(this.$refs)

            // this.$nextTick(() => {
            //     this.$refs.iframeDiv.innerHTML = ''
            // })

        },
        getVideoList1() {
            let that =this
            reqTempVideo()
                .then(function(res) {
                    console.log(res)
                    if (res.rtncode == 1) {
                        if (res.rltcode == 1) {
                            that.videoLists = res.item
                            console.log(that.videoLists)
                            that.videoLists.forEach(item => {
                                if (item.source === 1 && item.type === 1) {
                                    that.pcFunction.push(item)
                                } else if (item.source === 1 && item.type === 2) {
                                    that.pcApplication.push(item)
                                } else if (item.source === 2 && item.type === 1) {
                                    that.mobileFunction.push(item)
                                } else if (item.source === 2 && item.type === 2) {
                                    that.mobileApplication.push(item)
                                }
                            })
                        } else {
                            this.$Message.warning(res.rltdesc)
                            return
                        }
                    }else{
                         this.$Message.warning(res.rtndesc)
                         return
                    }

                }).catch(function(error) {
                    console.log(error);
                })
                .finally(function() {
                    // always executed
                });
        },
        // getVideoList() {
        //     var that = this
        //     var appid = 'admin'
        //     var pwd = '123456'
        //     const ajax2 = axios.create({
        //         baseURL: this.$baseConfig.wxServletUrl,
        //     })
        //     const headerParams = {
        //         xrd: randomWord(true, 10, 16), // 随机数
        //         xts: getTimeStamp(), // 时间戳
        //     }
        //     const md5Str = `appid=${appid}&pwd=${pwd}&randstr=${headerParams.xrd}&timestamp=${headerParams.xts}&body=`
        //     let url = '/apipublic/video/getinfo'
        //     let headers = {
        //         'content-type': 'application/json',
        //         'xappid': appid,
        //         'xrd': headerParams.xrd, // 随机数
        //         'xsn': md5(md5Str), // 加签
        //         'xts': headerParams.xts, // 时间戳
        //         'xen': 'true'
        //     }
        //     ajax2({
        //             url: url,
        //             headers: headers,
        //             method: 'get',
        //             //params: params,
        //             json: true
        //         })
        //         .then(function(response) {
        //             console.log(response)
        //             if (response.headers.xen === 'true') {
        //                 let key = getAeskey2(`${response.headers.xrd}`, pwd)
        //                 let data = TripleDES.decode(key, response.data)
        //                 that.videoLists = data.data
        //                 console.log(that.videoLists)
        //                 that.videoLists.forEach(item => {
        //                     if (item.source === 1 && item.type === 1) {
        //                         that.pcFunction.push(item)
        //                     } else if (item.source === 1 && item.type === 2) {
        //                         that.pcApplication.push(item)
        //                     } else if (item.source === 2 && item.type === 1) {
        //                         that.mobileFunction.push(item)
        //                     } else if (item.source === 2 && item.type === 2) {
        //                         that.mobileApplication.push(item)
        //                     }
        //                 })
        //             }
        //         })
        //         .catch(function(error) {
        //             // iView.LoadingBar.error()
        //             // reject(error);
        //             console.log(error);
        //         })
        //         .finally(function() {
        //             // always executed
        //         });

        // },

        // getVideoList() {
        //     this.videoLists.forEach(item => {
        //         if (item.source === 1 && item.type === 1) {
        //             this.pcFunction.push(item)
        //         } else if (item.source === 1 && item.type === 2) {
        //             this.pcApplication.push(item)
        //         }
        //     })
        // },
        // 鼠标移入显示预览图片
        previewImg(item, index) {
            console.log(index, item.type, item.source)
            this.mouseroverid = item.id
            if (item.type === 1) {
                this.mouseoverFlag1 = true
                this.mouseoverIndex1 = index
            } else if (item.type === 2) {
                this.mouseoverFlag2 = true
                this.mouseoverIndex2 = index
            }
        },
        // 鼠标移出
        backBgImg(item) {
            if (item.type === 1) {
                this.mouseoverFlag1 = false
            } else if (item.type === 2) {
                this.mouseoverFlag2 = false
            }
        },
        // 点击视频跳转播放页面
        playVidel(item, index, list) {
            //console.log(item, index)
            console.log('play index=====>' + index)
            //console.log(list)
            this.clearIframeVideo()
            //test
            //item.fileurl="https://player.youku.com/embed/XNDk5MzAyNDI2OA=="
            if (item.switchto === 1) {
                this.playH5Video(item, index)
            }

            if (item.switchto === 2) {
                this.playIframeVideo(item, index)

            }


        },
        playH5Video(item, index) {
            //console.log(item, index)
            this.videoPcType = item.type
            this.videoSource = item.source
            this.showPlayVideoTitle = item.title
            this.playSwitchto = item.switchto
            if (item.fileurl) {
                this.playFileurl = item.fileurl
                let v = `<video src="` + this.playFileurl + `" controls="controls" autoplay="autoplay" preload="auto"></video>`
                this.watchVideoPlayOrStop = true
                this.modal11 = true
                if (item.type === 1) {
                    this.playFunVideoIndex = index
                    this.playAppVideoIndex = -1
                } else {
                    this.playFunVideoIndex = -1
                    this.playAppVideoIndex = index
                }
                this.$refs.videoDiv.innerHTML += v

                // setTimeout(() => {
                //     this.$nextTick(() => this.$refs.videoDiv.innerHTML += v)
                // }, 1000)

            } else {
                this.$Message.warning({
                    content: '此视频暂时无法播放，请观看其他视频！',
                    duration: 3
                })
                this.watchVideoPlayOrStop = false
            }
        },
        playIframeVideo(item, index) {
            //console.log(item, index)
            this.videoPcType = item.type
            this.videoSource = item.source
            this.showPlayVideoTitle = item.title
            if (item.fileurl) {
                this.watchVideoPlayOrStop = true
            } else {
                this.$Message.warning({
                    content: '此视频暂时无法播放，请观看其他视频！',
                    duration: 3
                })
                this.watchVideoPlayOrStop = false
            }
            this.playSwitchto = item.switchto
            this.playFileurl = item.fileurl + "&high_quality=1"
            let ifra = `<iframe src="` + this.playFileurl + `" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true" width="95%"> </iframe>`
            this.modal11 = true

            if (item.type === 1) {
                this.playFunVideoIndex = index
                this.playAppVideoIndex = -1
            } else {
                this.playFunVideoIndex = -1
                this.playAppVideoIndex = index
            }




            this.$nextTick(() => {
                this.$refs.iframeDiv.innerHTML += ifra
            })
        },
        // 切换tab
        changeTab(type) {
            console.log('this.videoPcType:' + this.videoPcType, "type:" + type)
            this.videoPcType = type
            if (type === 1 && this.playFunVideoIndex === -1) {
                this.playFunVideoIndex = -1
            } else if (type === 2 && this.playAppVideoIndex === -1) {
                this.playAppVideoIndex = -1
            }
        },
        // 点击播放列表播放视频
        playVideo(item, index) {
            this.clearIframeVideo()
            console.log(item)
            if (item.switchto === 1) {
                if (item.fileurl) {
                    // this.playFunVideoIndex = index
                    // this.playAppVideoIndex = -1
                    // this.playFileurl = item.fileurl
                    // this.showPlayVideoTitle = item.title
                    // this.playSwitchto = item.switchto
                    // this.watchVideoPlayOrStop = true
                    this.playH5Video(item, index)

                } else {
                    this.$Message.warning({
                        content: '此视频暂时无法播放，请观看其他视频！',
                        duration: 3
                    })
                    this.watchVideoPlayOrStop = false
                    if (item.type === 1) {
                        this.playFunVideoIndex = index
                        this.playAppVideoIndex = -1
                        this.playFileurl = item.fileurl
                        this.showPlayVideoTitle = item.title
                    } else if (item.type === 2) {
                        this.playAppVideoIndex = index
                        this.playFunVideoIndex = -1
                        this.playFileurl = item.fileurl
                        this.showPlayVideoTitle = item.title
                    }
                }
            } else if (item.switchto === 2) {
                this.playIframeVideo(item, index)
            }


        },
        // 监听视频是播放还是暂停状态
        watchControlsClick() {

            // let video = document.getElementById('video')
            // const that = this
            // video.addEventListener('play', function() {
            //     that.watchVideoPlayOrStop = true
            // })
            // video.addEventListener('pause', function() {
            //     that.watchVideoPlayOrStop = false
            // })

        },
        // 鼠标移入
        videoHoverStyle(item, index) {
            if (item.type === 1) {
                this.mouseoverFlagTab1 = true
                this.mouseoverIndexTab1 = index
                this.mouseoverIndexTab2 = -1
            } else if (item.type === 2) {
                this.mouseoverFlagTab2 = true
                this.mouseoverIndexTab2 = index
                this.mouseoverIndexTab1 = -1
            }
        },
        // 鼠标移出
        videoOutStyle(item) {
            if (item.type === 1) {
                this.mouseoverFlagTab1 = false
            } else if (item.type === 2) {
                this.mouseoverFlagTab2 = false
            }
        }
    }
}
</script>
<style lang="scss">
#videoModule {
    .cover-img {
        width: 450px;
        height: 220px;
    }
}

.modalStyle {
    height: 98%;
}

.modal-warp {
    .ivu-modal {
        .ivu-modal-content {
            color: #fff;
            background: #1B212D;

            .ivu-modal-header {
                border-bottom: 1px solid transparent;

                .ivu-modal-header-inner {
                    color: #fff;
                    font-size: 25px;
                    height: 25px;
                    line-height: 25px;
                }
            }

            .ivu-modal-body {
                padding: 0;
            }
        }
    }
}

#video {
    min-width: 420px;
    max-height: 800px;
    max-width: 100%;
    height: 100%;
    object-fit: fill;

    &:focus {
        outline: none;
    }
}

.videoContent {
    text-align: center;
    background: black;
    margin: 0 10px;
}

.videoContent1 {
    text-align: center;
    background: black;
    margin: 0 10px;
    height: 100%;
    min-width: 420px;
    max-height: 800px;
    object-fit: fill;
    //height: 78vh;
}

.iframe_video {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;

}

.iframe_video iframe,
.iframe_video object,
.iframe_video embed,
.iframe_video video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 98%;
    padding-right: 10px;
}
</style>